import { useTranslation } from 'react-i18next'
import i18n from './index'

import ITranslationKeys from './translations/ITranslationKeys'

type I18NContext = { context: string }

export const useI18N = () => {
  const { t } = useTranslation()
  t('error.unexpected', { context: 'error' })
  const enTranslator = i18n.getFixedT('en')
  const esTranslator = i18n.getFixedT('es')
  return {
    t: (arg: keyof ITranslationKeys | `error.${string}`, context?: I18NContext, lang?: string) => {
      if(lang === 'es') {
        return esTranslator(arg, context)
      } else if (lang === 'en') {
        return enTranslator(arg, context)
      }
      return t(arg, context)
    },
    currentLanguage: i18n.language
  }
}
